import React, { useState } from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";

/**
 * Petite pastille « ? » qui ouvre une bulle d'aide (au survol / clic).
 * Sert à rendre l'écran baromètre auto-explicatif.
 *
 * <Help title="…">texte d'explication</Help>
 */
const Help = ({ title, children, placement = "right" }) => {
  const [id] = useState(() => "help-" + Math.random().toString(36).slice(2, 8));

  const popover = (
    <Popover id={id} style={{ maxWidth: 320 }}>
      {title && <Popover.Title as="h3">{title}</Popover.Title>}
      <Popover.Content style={{ fontSize: 13, lineHeight: 1.4 }}>{children}</Popover.Content>
    </Popover>
  );

  return (
    <OverlayTrigger trigger={["hover", "focus", "click"]} placement={placement} overlay={popover}>
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: 16,
          height: 16,
          borderRadius: "50%",
          background: "#429853",
          color: "#fff",
          fontSize: 11,
          fontWeight: "bold",
          cursor: "help",
          marginLeft: 6,
          lineHeight: 1,
          verticalAlign: "middle",
        }}
      >
        ?
      </span>
    </OverlayTrigger>
  );
};

export default Help;
